/**
 * Registers the 'asfCarousel' directive with the provided module.
 * This directive is used to create a carousel component with various configurable options.
 * 
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerAsfCarouselDirective(module) {
    module.directive('asfCarousel',
        ['$routeParams', '$config',
            function ($routeParams, $config) {
                // Directive factory
                return {
                    restrict: 'EA', // Allow the directive to be used as an element or attribute
                    scope: {
                        contentObj: "=", // Two-way binding for content object
                        rowKey: "=", // Two-way binding for row key
                        containerKey: "=", // Two-way binding for container key
                        colKey: "=", // Two-way binding for column key
                        rows: "=", // Two-way binding for rows

                        connectWith: "=", // Two-way binding for connectWith option
                        sortableOption: "=", // Two-way binding for sortable options

                        activeCarousel: "=?", // Optional two-way binding for active carousel
                        isReadingTime: '=', // Two-way binding for isReadingTime flag
                        size: "=", // Two-way binding for size
                        questionPart: "=" // Two-way binding for question part
                    },
                    /**
                     * Determines the template URL based on configuration and mode.
                     * @returns {string} The URL of the template to be used.
                     */
                    templateUrl: function () {
                        const isCMS = typeof $config.isCMS === 'function' ? $config.isCMS() : false;
                        if (!$config.isPreviewMode() && isCMS && !$config.isPDFMode()) {
                            return '/views/ib/components/carousel/CarouselDirectiveCMS.html';
                        }
                        return '/views/ib/components/carousel/CarouselDirective.html';
                    },
                    controller: 'IBCarouselController' // Specifies the controller for this directive
                };
            }]
        );
}